import React from 'react';

import { Button, createStyles, Drawer, Stack, MultiSelect } from '@mantine/core';
import { AthletePackage } from 'types';

export interface AthletePackageSearchFilters {
  statuses: AthletePackage['status'][];
}

const statusOptions: AthletePackageSearchFilters['statuses'] = [
  'ACTIVE',
  'UPCOMING',
  'ENDED',
  'CANCELLED',
  'HOLD',
];

const useStyles = createStyles(theme => ({
  drawer: {
    justifyContent: 'flex-start',
  },
  button: {
    width: 'min-content',
    marginLeft: 'auto',
    marginBottom: theme.spacing.md,
  },
}));

interface ISchedulingPageHeaderProps {
  opened: boolean;
  searchFilters: AthletePackageSearchFilters;
  setSearchFilters: React.Dispatch<React.SetStateAction<AthletePackageSearchFilters>>;
  closeFilters: () => void;
  permission?: boolean;
}

const FiltersDrawer = ({
  opened,
  searchFilters,
  setSearchFilters,
  closeFilters,
}: ISchedulingPageHeaderProps): JSX.Element => {
  const { classes } = useStyles();

  const handleClearFilters = (): void => {
    setSearchFilters({ statuses: [] });
  };
  const handleIsShowHistoricalChange = (value: AthletePackageSearchFilters['statuses']): void => {
    setSearchFilters(prev => ({ ...prev, statuses: value }));
  };

  return (
    <Drawer position='bottom' opened={opened} onClose={closeFilters} className={classes.drawer}>
      <Stack spacing='sm' justify='flex-start'>
        <Button color='red' onClick={handleClearFilters} className={classes.button}>
          Clear Filters
        </Button>
        <MultiSelect
          pr='xl'
          miw={350}
          placeholder='Select statuses'
          clearable
          data={statusOptions}
          value={searchFilters.statuses}
          onChange={handleIsShowHistoricalChange}
        />
      </Stack>
    </Drawer>
  );
};

export default FiltersDrawer;
